import { render } from "./InscricoesPage.vue?vue&type=template&id=f6542b72&scoped=true"
import script from "./InscricoesPage.vue?vue&type=script&lang=js"
export * from "./InscricoesPage.vue?vue&type=script&lang=js"

import "./InscricoesPage.vue?vue&type=style&index=0&id=f6542b72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6542b72"]])

export default __exports__